module.exports = __webpack_public_path__ + "assets/icons/ic_circle_x_24px.svg";